import { Link, IconName } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { usePlatformPrivilege, usePrivilege } from '@mews-commander/core';
import { handleCopyToClipboard } from '../../utils';

export const CopyInviteButton = ({ userId }: { userId: string }) => {
    const isAdmin = usePrivilege('admin');
    const canAccessAllEnterprises = usePlatformPrivilege('accessAllEnterprises');

    const { mutate } = useRepositoryMutation('userProfiles', 'getInviteLink', {
        onSuccess: ({ link }) => handleCopyToClipboard(link),
    });

    const handleInviteLink = () => mutate({ userId });

    if (!(isAdmin || canAccessAllEnterprises)) {
        return null;
    }

    return (
        <Link as="button" icon={IconName.Copy} onClick={handleInviteLink} variant="basic" size="small" standalone>
            <LocalizedText textKey={TextKey.UserProfileCopyInviteLinkText} />
        </Link>
    );
};
